import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

// components
import FiltersMapForm from "./_form";
import FiltersMapFilters from "./_filters";
import {GenericButton} from "../../../components/buttons/customButtons";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// labels
import {LIST} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {filtersMapService} from "../../../jwt/_services/clasificator/filtersMapService";

const FiltersMapList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    useEffect( () => {
        if( !app.id || !udn.id || filter)
            return

        props.setFilter(path , {
            onlyRegistered : true,
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                udn : { id: udn.id },
                status: true,
            }
        });
    }, [ app, udn ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, filtersMapService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);


    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex, totalSize, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( FiltersMapForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(FiltersMapForm, { path, data, Form: FiltersMapForm })
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({path, remove : genericIndexedActions.delete , data : data, fbDataBaseId :  app?.fbDataBase?.id, service: filtersMapService } );
    };

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={filtersMapService} path={path}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: {width: '200px'},
    }, {
        dataField: 'name',
        text: 'Nombre'
    }, {
        dataField: 'code',
        text: 'Codigo'
    }, {
        dataField: 'type',
        headerAlign: 'center',
        align: 'center',
        text: "Tipo",
        headerStyle: {width: '150px'},
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '120px'},
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '15%'},
        headerAlign: 'center',
        align: 'center',
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <FiltersMapFilters path={path}/>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects}
                columns={columns}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(FiltersMapList)